var React = require('react');

function IconLowRate (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polyline",{"className":"icon-line--style icon-line--linecap","points":"31 28.82 31 68.43 8 68.43 64 111.18 120 68.43 97 68.43 97 28.82","key":0}),React.createElement("line",{"className":"icon-line--style icon-line--linecap","x1":"74.16","y1":"28.82","x2":"53.84","y2":"69.33","key":1}),React.createElement("circle",{"className":"icon-line--style icon-line--linecap","cx":"75.16","cy":"61.68","r":"7.65","key":2}),React.createElement("circle",{"className":"icon-line--style icon-line--linecap","cx":"52.84","cy":"36.47","r":"7.65","key":3})]));
}

IconLowRate.defaultProps = {"id":"icon-lowrate","viewBox":"0 0 128 128"};

module.exports = IconLowRate;

IconLowRate.default = IconLowRate;
